export const mockData = {
  businessInfo: {
    name: "DI NAPOLI PIZZA",
    phone: "01 69 28 14 14",
    address: "50 Rue de la Ferme, 91400 Orsay",
    mapUrl: "https://google.com/maps/place/Di+Napoli+Pizza/@48.6851694,2.182295,20.18z/data=!4m15!1m8!3m7!1s0x47e5d60ef61fc3eb:0xc8c55ba1037949c5!2s50+Rue+de+la+Ferme,+91400+Orsay!3b1!8m2!3d48.6851375!4d2.1825689!16s%2Fg%2F11bw3xrmhf!3m5!1s0x47e5d60ef5eeeaa5:0x168604c892220e3!8m2!3d48.6850874!4d2.1825293!16s%2Fg%2F1tf3n68r?entry=ttu&g_ep=EgoyMDI1MDkxNi4wIKXMDSoASAFQAw%3D%3D",
    features: [
      "100% Halal",
      "Pâte fraîche faite maison",
      "Livraison gratuite 7j/7 (min 15 €)",
      "Paiements CB & tickets restaurant"
    ]
  },
  
  galleryImages: [
    {
      url: "https://images.unsplash.com/photo-1563245738-9169ff58eccf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwxfHxwaXp6YSUyMHJlc3RhdXJhbnR8ZW58MHx8fHwxNzU4MjU0MTA5fDA&ixlib=rb-4.1.0&q=85",
      alt: "Assortiment de pizzas DI NAPOLI"
    },
    {
      url: "https://images.unsplash.com/photo-1566843972142-a7fcb70de55a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwyfHxwaXp6YSUyMHJlc3RhdXJhbnR8ZW58MHx8fHwxNzU4MjU0MTA5fDA&ixlib=rb-4.1.0&q=85",
      alt: "Pizza artisanale sur planche en bois"
    },
    {
      url: "https://images.unsplash.com/photo-1513104890138-7c749659a591?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwxfHxwaXp6YXxlbnwwfHx8fDE3NTgzMTI4NzV8MA&ixlib=rb-4.1.0&q=85",
      alt: "Pizza gastronomique aux fruits"
    },
    {
      url: "https://images.unsplash.com/photo-1552332386-f8dd00dc2f85",
      alt: "Tacos frais avec garnitures"
    },
    {
      url: "https://images.unsplash.com/photo-1505253716362-afaea1d3d1af",
      alt: "Salade fraîche du restaurant"
    },
    {
      url: "https://images.unsplash.com/photo-1571877227200-a0d98ea607e9",
      alt: "Tiramisu maison"
    }
  ]
};